<template>
    <div id="joat_main" :style="vertical ? 'flex-direction: column' : ''">
        <i id="joat_icon" class="fas fa-database"></i>
        <span class="ff-kanit">{{ app_name.toUpperCase() }}</span>
    </div>
</template>

<script>
  export default {
    name: 'joat',
    props: {
      vertical: {
        type: Boolean,
        default: false
      }
    },
    data(){
      return{
        app_name: process.env.VUE_APP_NAME
      }
    }
  }
</script>

<style scoped>
    #joat_main{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    #joat_icon{
        margin-right: 5px;
    }
</style>
